const BD_VAT_STORAGE_KEY = 'pricesIncludeVat';

let bdVatFormatterRetryTimer = null;
let bdVatFormatterRetryCount = 0;

function getBdVatState() {
  return sessionStorage.getItem(BD_VAT_STORAGE_KEY) === 'true';
}

function getBdVatInput(toggleOrInput) {
  if (toggleOrInput instanceof HTMLInputElement) {
    return toggleOrInput;
  }

  if (toggleOrInput instanceof Element) {
    return toggleOrInput.matches('input[name="vat-switcher"]')
      ? toggleOrInput
      : toggleOrInput.querySelector('input[name="vat-switcher"]');
  }

  const eventTarget = window.event?.target;

  return eventTarget instanceof HTMLInputElement &&
    eventTarget.matches('input[name="vat-switcher"]')
    ? eventTarget
    : null;
}

function synchronizeBdVatSwitches(includeVAT) {
  document
    .querySelectorAll('input[name="vat-switcher"]')
    .forEach((input) => {
      input.checked = includeVAT;
      input.setAttribute('aria-checked', String(includeVAT));
    });

  document
    .querySelectorAll('.vat-switcher-toggle')
    .forEach((toggle) => {
      toggle
        .querySelectorAll('.toggler')
        .forEach((toggler) => {
          toggler.classList.toggle('left-22', includeVAT);
          toggler.classList.toggle('left-2', !includeVAT);
        });
    });

  document
    .querySelectorAll('.vat-switcher-title')
    .forEach((title) => {
      title.textContent = includeVAT
        ? 'incl. btw'
        : 'excl. btw';
    });
}

function scheduleBdPriceSummaryRefresh() {
  if (typeof window.updateBdPriceSummary !== 'function') {
    return;
  }

  [0, 50, 150].forEach((delay) => {
    window.setTimeout(() => {
      window.updateBdPriceSummary();
    }, delay);
  });
}

/*
 * Shopify.formatMoney kan bij de eerste uitvoering van dit bestand
 * nog niet beschikbaar zijn. De lokale fallback voorkomt dat de
 * initialisatie daardoor afbreekt en de eventlisteners niet worden
 * geregistreerd.
 */
function formatBdVatMoney(priceInCents) {
  const normalizedPrice = Number(priceInCents) || 0;

  if (
    window.Shopify &&
    typeof window.Shopify.formatMoney === 'function'
  ) {
    return window.Shopify.formatMoney(
      normalizedPrice,
      '€{{amount_with_comma_separator}}'
    );
  }

  return new Intl.NumberFormat(
    'nl-NL',
    {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  ).format(normalizedPrice / 100);
}

/*
 * Zodra Shopify.formatMoney later beschikbaar komt, worden de prijzen
 * nogmaals met de vaste Shopify-opmaak uitgevoerd.
 */
function scheduleBdVatFormatterRefresh() {
  if (
    window.Shopify &&
    typeof window.Shopify.formatMoney === 'function'
  ) {
    bdVatFormatterRetryCount = 0;

    if (bdVatFormatterRetryTimer) {
      window.clearTimeout(bdVatFormatterRetryTimer);
      bdVatFormatterRetryTimer = null;
    }

    calculatePrices(getBdVatState());
    scheduleBdPriceSummaryRefresh();
    return;
  }

  if (bdVatFormatterRetryCount >= 50) {
    return;
  }

  bdVatFormatterRetryCount += 1;

  if (bdVatFormatterRetryTimer) {
    window.clearTimeout(bdVatFormatterRetryTimer);
  }

  bdVatFormatterRetryTimer = window.setTimeout(
    scheduleBdVatFormatterRefresh,
    100
  );
}

function applyBdVatState(includeVAT) {
  const normalizedState = Boolean(includeVAT);

  sessionStorage.setItem(
    BD_VAT_STORAGE_KEY,
    normalizedState ? 'true' : 'false'
  );

  synchronizeBdVatSwitches(normalizedState);
  calculatePrices(normalizedState);
  updateTextToVat(normalizedState);
  synchronizeBdVatSwitches(normalizedState);
  scheduleBdPriceSummaryRefresh();
  scheduleBdVatFormatterRefresh();
}

function toggleTaxPrices(toggleOrInput) {
  const input = getBdVatInput(toggleOrInput);

  const nextState = input
    ? input.checked
    : !getBdVatState();

  applyBdVatState(nextState);
}

function calculatePrices(includeVAT) {
  const prices = document.querySelectorAll('[data-excl-price]');

  prices.forEach((priceElement) => {
    /*
     * Zolang de productkeuze nog niet compleet is, blijft in de
     * hoofdproductregel de vaste tekst staan. Alle andere prijzen
     * blijven ongewijzigd door de bestaande btw-berekening lopen.
     */
    const isPendingMainProductPrice =
      priceElement.matches('[data-bd-main-total]') &&
      priceElement
        .closest('[data-bd-price-summary]')
        ?.getAttribute('data-bd-selection-complete') !== 'true';

    if (isPendingMainProductPrice) {
      priceElement.textContent = 'Prijs na selectie';
      return;
    }

    const exclPrice = Number.parseFloat(
      priceElement.dataset.exclPrice
    );

    if (!Number.isFinite(exclPrice)) {
      console.error(
        'Invalid price found on element:',
        priceElement
      );
      return;
    }

    const vatPercentage = 21;
    const inclPrice =
      exclPrice * (1 + vatPercentage / 100);

    priceElement.innerHTML = includeVAT
      ? formatBdVatMoney(inclPrice)
      : formatBdVatMoney(exclPrice);
  });
}

function updateTextToVat(includeVAT) {
  const texts = document.querySelectorAll(
    '*:not(script):not(style)'
  );

texts.forEach((element) => {
  if (element.closest('[data-fixed-vat-text]')) {
    return;
  }

  element.childNodes.forEach((node) => {

      if (node.nodeType !== Node.TEXT_NODE) {
        return;
      }

      let text = node.textContent;

      if (includeVAT) {
        text = text
          .replace(/excl\. BTW/g, 'incl. btw')
          .replace(/excl\. btw/g, 'incl. btw')
          .replace(/Excl\. BTW/g, 'incl. btw');
      } else {
        text = text
          .replace(/incl\. BTW/g, 'excl. btw')
          .replace(/incl\. btw/g, 'excl. btw')
          .replace(/Incl\. BTW/g, 'excl. btw');
      }

      node.textContent = text;
    });
  });
}

function updateToggleVisuals(toggle, includeVAT) {
  synchronizeBdVatSwitches(Boolean(includeVAT));
}

function bindBdVatSwitcherEvents() {
  if (
    document.documentElement.dataset.bdVatSwitcherBound ===
    'true'
  ) {
    return;
  }

  document.documentElement.dataset.bdVatSwitcherBound = 'true';

  /*
   * De productswitch staat binnen het configuratorpaneel.
   * Deze expliciete klikafhandeling werkt voor het gouden vlak,
   * het witte bolletje en de bijbehorende tekst.
   */
  document.addEventListener(
    'click',
    (event) => {
      const productSwitch = event.target.closest?.(
        '.bd-product-vat-switch'
      );

      if (!productSwitch) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      applyBdVatState(!getBdVatState());
    },
    true
  );

  /*
   * Native change-events blijven actief voor de header-, menu-
   * en toetsenbordbediening. De actuele checkboxwaarde wordt
   * toegepast, zodat dezelfde status niet dubbel wordt omgedraaid.
   */
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest?.(
        'input[name="vat-switcher"]'
      );

      if (!input) {
        return;
      }

      applyBdVatState(input.checked);
    },
    true
  );
}

function initializeBdVatSwitcher() {
  const storedState =
    sessionStorage.getItem(BD_VAT_STORAGE_KEY);

  /*
   * Een nieuwe browsersessie begint standaard exclusief btw.
   * Een geldige keuze binnen dezelfde sessie blijft behouden.
   */
  if (storedState !== 'true' && storedState !== 'false') {
    sessionStorage.setItem(BD_VAT_STORAGE_KEY, 'false');
  }

  /*
   * Eventlisteners eerst registreren. Zo blijft de productswitch
   * bruikbaar, ook wanneer een prijsformatter iets later laadt.
   */
  bindBdVatSwitcherEvents();
  applyBdVatState(getBdVatState());
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeBdVatSwitcher,
    { once: true }
  );
} else {
  initializeBdVatSwitcher();
}

document.addEventListener(
  'shopify:section:load',
  initializeBdVatSwitcher
);
